import React from "react";
import { Box, Typography, IconButton, Stack } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ModernPageShell from "components/ModernPageShell";
import { colors } from "components/Theme/WebTheme.js";
import { MOVEX_UI } from "../common/movexUiTheme";

export default function ContactUs() {
  const { t } = useTranslation();
  const settings = useSelector(state => state.settingsdata.settings);

  const socialLinks = [
    { show: settings?.FacebookHandle, href: settings?.FacebookHandle, title: t('follow_facebook'), icon: 'fab fa-facebook', color: colors.FACEBOOK_COLOR },
    { show: settings?.TwitterHandle, href: settings?.TwitterHandle, title: t('follow_twitter'), icon: 'fab fa-twitter', color: colors.BLUE },
    { show: settings?.InstagramHandle, href: settings?.InstagramHandle, title: t('follow_instagram'), icon: 'fab fa-instagram', color: colors.VIOLET },
  ].filter(item => item.show);

  return (
    <ModernPageShell
      title={t('contact_us')}
      subtitle={!settings?.contactUsContent ? t('contact_us_sub', { defaultValue: 'Escríbenos y te respondemos pronto.' }) : undefined}
    >
      {settings?.contactUsContent ? (
        <p style={{ whiteSpace: 'pre-line', marginBottom: '1.5rem' }}>{settings.contactUsContent}</p>
      ) : null}

      {settings?.CompanyName ? (
        <Typography sx={{ fontWeight: 700, fontSize: 20, color: MOVEX_UI.text, mb: 0.5 }}>
          {settings.CompanyName}
        </Typography>
      ) : null}

      {settings?.CompanyAddress ? (
        <Typography sx={{ mb: 2 }}>{settings.CompanyAddress}</Typography>
      ) : null}

      {settings?.contact_email ? (
        <p>
          <span>{t('email')}: </span>
          <a href={`mailto:${settings.contact_email}`}>{settings.contact_email}</a>
        </p>
      ) : null}

      {settings?.CompanyPhone ? (
        <p>{t('phone')}: {settings.CompanyPhone}</p>
      ) : null}

      {socialLinks.length > 0 ? (
        <Box sx={{ mt: 3 }}>
          <Typography sx={{ fontWeight: 600, color: MOVEX_UI.text, mb: 1 }}>
            {t('follow_us', { defaultValue: 'Síguenos' })}
          </Typography>
          <Stack direction="row" spacing={0.5}>
            {socialLinks.map((item, idx) => (
              <Tooltip key={idx} title={item.title}>
                <IconButton
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    border: `1px solid ${MOVEX_UI.cardBorder}`,
                    bgcolor: MOVEX_UI.accentSoft,
                    '&:hover': { bgcolor: 'rgba(6,200,109,0.2)', borderColor: MOVEX_UI.accent },
                  }}
                >
                  <i className={item.icon} style={{ color: item.color, fontSize: 18 }} />
                </IconButton>
              </Tooltip>
            ))}
          </Stack>
        </Box>
      ) : null}
    </ModernPageShell>
  );
}
